import { Injectable } from "@angular/core";
import { DataService } from "../data.service";
import { environment } from "../../../environments/environment";
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { PosUserResponse } from 'src/app/models/pos-user-response';
import { CommonFunctionService } from './../Common/common-function.service';
@Injectable()
export class ForgotpasswordService {
  headers:any;
  token:any;
  constructor(private service: DataService, private http:HttpClient,private commonfunction: CommonFunctionService) {}

  forgotPassword(data) {
    return this.service.create(environment.forgotPassword, data);
  }

  checkUserEmailAddress(data)
  {
    return this.http.get<any>(environment.merchantuserdetailsUrl+"?email="+data);
  }
  checkUserDetails(email,userType)
  {
    this.GetUserAuthdetails();
    return this.http.get<PosUserResponse>(environment.checkUserdetailsUrl+"?email="+email+"&usertype="+userType,{ headers:this.headers });
  }
    
  checkMMSUserDetails(email,userType)
  {
    this.GetUserAuthdetails();
    return this.http.get<PosUserResponse>(environment.checkMMSUserdetailsUrl+"?email="+email+"&usertype="+userType,{ headers:this.headers });
  }
  forgotPasswords(data) {
this.GetUserAuthdetails();
    return this.http.post(environment.forgotPasswords, data,{ headers:this.headers});
  }


  GetUserAuthdetails()
  {
    this.token = "" + ":" + environment.GetAuthenticationToken + ":" +'IT';
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
  }
}
